import React from 'react';
import { DialogActions } from '@material-ui/core';

const ResponsiveDialogActions: React.FC = ({ children }) => {
  return (
    <DialogActions>
      {children}
    </DialogActions>
  )
}

export default ResponsiveDialogActions;
